// @flow

import { useEffect } from 'react';

const hasBody = () => {
  return typeof document !== 'undefined' && !!document.body;
};

const useUnscrollableBody = ({
  shouldAllowScroll,
}: {
  shouldAllowScroll: boolean,
}) => {
  useEffect(() => {
    if (hasBody()) {
      // $FlowFixMe
      document.body.style.overflow = shouldAllowScroll ? '' : 'hidden';
    }
    return () => {
      if (hasBody()) {
        // $FlowFixMe
        document.body.style.overflow = '';
      }
    };
  }, [shouldAllowScroll]);
};

export default useUnscrollableBody;
